import socketio from 'socket.io-client';
import React from 'react';
const websocket = process.env.REACT_APP_WEBSOCKET_HOST;

export const socket = socketio.connect(websocket);
socket.on('connect', () => {});
export const SocketContext = React.createContext();
